import { TranslateService } from '@ngx-translate/core';
import { inject, Pipe, PipeTransform } from '@angular/core';
import { ConnectionStatus } from '../../models/scanner';

@Pipe({ name: 'toScannerStatusBadge' })
export class ScannerStatusPipe implements PipeTransform {
  private translate = inject(TranslateService);

  transform(scannerStatus: ConnectionStatus): string {
    let status;
    let badge;
    switch (scannerStatus) {
      case ConnectionStatus.ACTIVE:
        status = 'ACTIVE';
        badge = 'active';
        break;
      default:
        status = 'INACTIVE';
        badge = 'inactive';
        break;
    }
    const text = this.translate.instant(status);
    return (
      `<div class="badge rounded-pill text-bg-light" translate><div class="dot ${badge}"></div>${text}</div>`
    );
  }
}
